import { type FieldValues } from 'react-hook-form'

import {
  type ITrackedAirframePermission,
  type IBaseResponse,
  type ITrackedAirframe,
  type IGetAirframeResponse,
  type IGetTransferTypeResponse,
  type IGetTailResponse
} from 'platform-core'
import { CoreAirframeService } from 'platform-core/ui'
import {
  type BaseValuesResponse,
  type IGetAirframeInviteResponse,
  type IFinishSignUpResponse
} from '@/models'
import { submitRequest } from '@/util'

export class AirframeService extends CoreAirframeService {
  constructor () {
    super(submitRequest)
  }

  async updateTransferInvite (inviteId: string, payload: FieldValues): Promise<IBaseResponse> {
    let response: IGetTransferTypeResponse
    try {
      response = await submitRequest<IGetTransferTypeResponse>(
        'post',
        `v1/airframe/transfer/${inviteId}`,
        payload
      )
    } catch (e: any) {
      throw new Error(e)
    }
    return response
  }

  async getTransferInvite (inviteId: string): Promise<IGetTransferTypeResponse> {
    let response: IGetTransferTypeResponse
    try {
      response = await submitRequest<IGetTransferTypeResponse>(
        'get',
        `v1/airframe/transfer/${inviteId}`
      )
    } catch (e: any) {
      throw new Error(e)
    }
    return response
  }

  async getAirframe (tailNumber: string): Promise<ITrackedAirframe> {
    let response: IGetAirframeResponse
    try {
      response = await submitRequest<IGetAirframeResponse>(
        'get',
        `v1/airframe/${tailNumber}`
      )
    } catch (e: any) {
      throw new Error(e)
    }
    return response.record
  }

  async updateInvitedAccount (inviteId: string, payload: FieldValues): Promise<IFinishSignUpResponse> {
    let response: IFinishSignUpResponse
    try {
      response = await submitRequest<IFinishSignUpResponse>(
        'post',
        `v1/airframe/invite/${inviteId}`,
        payload
      )
    } catch (e: any) {
      throw new Error(e)
    }
    return response
  }

  async getAirframeInvite (inviteId: string): Promise<ITrackedAirframePermission> {
    let response: IGetAirframeInviteResponse
    try {
      response = await submitRequest<IGetAirframeInviteResponse>(
        'get',
        `v1/airframe/invite/${inviteId}`
      )
    } catch (e: any) {
      throw new Error(e)
    }
    return response.invite
  }

  async processPermissionInvite (airframeId: string, permissionId: string, accepted: boolean): Promise<boolean> {
    let response: IBaseResponse
    try {
      response = await submitRequest<IBaseResponse>(
        'put',
        `v1/airframe/${airframeId}/permission/${permissionId}`,
        { accepted }
      )
    } catch (e: any) {
      throw new Error(e)
    }
    return response.success
  }

  async tailSearch (query: string): Promise<string[]> {
    let response: BaseValuesResponse
    try {
      response = await submitRequest<BaseValuesResponse>(
        'post',
        'v1/airframe/tail/search',
        { query }
      )
    } catch (e: any) {
      throw new Error(e)
    }
    return response.values
  }

  async loadTail (tailNumber: string): Promise<IGetTailResponse> {
    let response: IGetTailResponse
    try {
      response = await submitRequest<IGetTailResponse>(
        'get',
        `v1/airframe/tail/${tailNumber}`
      )
    } catch (e: any) {
      throw new Error(e)
    }
    return response
  }
}
